import { render, staticRenderFns } from "./CoordinatorList.vue?vue&type=template&id=0103d493&"
import script from "./CoordinatorList.vue?vue&type=script&lang=js&"
export * from "./CoordinatorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports